import React from 'react';
import { Site } from '../../lib/Site';
import FooterLinksItem from '../FooterLinksMenu/FooterLinksItem';

interface Props {
    site: Site;
}
export default function GetDesignMenu({ site }: Props) {
    return (
        <div className="footer-links-menu">
            <ul className="footer-links-menu__items">
                <FooterLinksItem label={__('Logo design')} url="/logo-design" />
                <FooterLinksItem label={__('Business card')} url="/business-card-design" />
                <FooterLinksItem label={__('Web page design')} url="/web-design" />
                <FooterLinksItem label={__('Brand guide')} url="/brand-guide" />
                <FooterLinksItem label={__('Packaging design')} url="/product-packaging-design" />
                <FooterLinksItem label={__('T-shirt design')} url="/t-shirt-design" />
                <FooterLinksItem label={__('Book cover design')} url="/book-cover-design" />
                <FooterLinksItem label={__('Browse all categories')} url="/categories" />
            </ul>
        </div>
    );
}
